/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Clear_TeamInputs */

const en_us2_clubs_clear_team = /** @type {(inputs: Clubs_Clear_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take off the team`)
};

const pt_br2_clubs_clear_team = /** @type {(inputs: Clubs_Clear_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar do time`)
};

const es_419_clubs_clear_team = /** @type {(inputs: Clubs_Clear_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sacar del equipo`)
};

const pt_pt2_clubs_clear_team = /** @type {(inputs: Clubs_Clear_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar da equipa`)
};

const fr_fr2_clubs_clear_team = /** @type {(inputs: Clubs_Clear_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer de l'équipe`)
};

const de_de2_clubs_clear_team = /** @type {(inputs: Clubs_Clear_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus dem Team nehmen`)
};

const it_it2_clubs_clear_team = /** @type {(inputs: Clubs_Clear_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Togli dalla squadra`)
};

/**
* | output |
* | --- |
* | "Take off the team" |
*
* @param {Clubs_Clear_TeamInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_clear_team = /** @type {((inputs?: Clubs_Clear_TeamInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Clear_TeamInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_clear_team(inputs)
	if (locale === "es-419") return es_419_clubs_clear_team(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_clear_team(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_clear_team(inputs)
	if (locale === "de-DE") return de_de2_clubs_clear_team(inputs)
	if (locale === "it-IT") return it_it2_clubs_clear_team(inputs)
	return en_us2_clubs_clear_team(inputs)
});
export { clubs_clear_team as "clubs.clear_team" }